import { apiFetch } from '../fetch';

export interface UserPreferences {
  watchRegion: string;
  streamingServices: number[];
}

/**
 * Fetches all user preferences from the API.
 * Returns defaults (empty region, empty services) on failure.
 */
export async function fetchUserPreferences(
  authHeader?: string
): Promise<UserPreferences> {
  try {
    const headers = authHeader ? { Authorization: authHeader } : undefined;
    const response = await apiFetch('/api/me/preferences', { headers });
    if (response.ok) {
      const json = (await response.json()) as {
        data?: {
          attributes?: {
            watchRegion?: string;
            streamingServices?: number[];
          };
        };
      };
      return {
        watchRegion: json.data?.attributes?.watchRegion ?? '',
        streamingServices: json.data?.attributes?.streamingServices ?? [],
      };
    }
  } catch {
    // Silently fail — preference loading is not critical
  }
  return { watchRegion: '', streamingServices: [] };
}

/**
 * Fetches the user's watch region preference from the API.
 * Returns the 2-letter ISO region code, or empty string if not set.
 */
export async function fetchWatchRegion(authHeader?: string): Promise<string> {
  const prefs = await fetchUserPreferences(authHeader);
  return prefs.watchRegion;
}
